import { render, staticRenderFns } from "./PillBox.vue?vue&type=template&id=0de34e71&scoped=true"
import script from "./PillBox.vue?vue&type=script&lang=js"
export * from "./PillBox.vue?vue&type=script&lang=js"
import style0 from "./PillBox.vue?vue&type=style&index=0&id=0de34e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de34e71",
  null
  
)

export default component.exports